/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContratGridDto } from './ContratGridDto';
import {
    ContratGridDtoFromJSON,
    ContratGridDtoFromJSONTyped,
    ContratGridDtoToJSON,
} from './ContratGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContratGridDtoPaginatedResults
 */
export interface ContratGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContratGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContratGridDto>}
     * @memberof ContratGridDtoPaginatedResults
     */
    results?: Array<ContratGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContratGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContratGridDtoPaginatedResults interface.
 */
export function instanceOfContratGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratGridDtoPaginatedResultsFromJSON(json: any): ContratGridDtoPaginatedResults {
    return ContratGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContratGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContratGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContratGridDtoPaginatedResultsToJSON(value?: ContratGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContratGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

